import { useEffect } from 'react';
import i18n from '@/i18n/i18n';
import { useResolvedTheme } from './theme';
import { useAppStore } from './appStore';

/**
 * Applies app-level UI preferences (theme + locale) globally.
 */
export function UiPreferencesBridge() {
  const themePreference = useAppStore((s) => s.theme);
  const locale = useAppStore((s) => s.locale);
  const resolvedTheme = useResolvedTheme(themePreference);

  useEffect(() => {
    document.documentElement.classList.remove('dark', 'light');
    document.documentElement.classList.add(resolvedTheme);
    document.documentElement.setAttribute('data-theme', resolvedTheme);
    document.documentElement.setAttribute('data-theme-preference', themePreference);
  }, [resolvedTheme, themePreference]);

  useEffect(() => {
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
  }, [locale]);

  return null;
}
